import { PaginationParams } from 'SharedDir/declarations/pagination';

export type ParamsAllRecords = Omit<PaginationParams<object>, 'rowsPerPage' | 'page'>;

export const paramsAllRequest: Omit<PaginationParams<object>, 'rowsPerPage' | 'page'> = {
  sortBy: 'id',
  descending: false,
};
